import "./ProductDetails.css";

import ProductCard from "../../CustomComponents/ProductCard";
import React from "react";

export const ProductDetails = props => {
  if (!props.products) {
    return null;
  }
  return (
    <div className="product-details">
      <section className="product-details-container">
        {props.products.categories.map(category => (
          <div key={category.name} className="category">
            <h1 className="category-name">{category.name}</h1>
            <div className="items">
              {category.items.map(item => (
                <ProductCard item={item} key={item.name} />
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default ProductDetails;
